<template>
  <div>
    <div class="btn-wrapper mb-10 move-right">
      <button @click="$router.go(-1)" class="btn-back">
        <span>Back</span>
      </button>
    </div>
    <div class="white-bg">
      <h3 class="bold mb-20">Reports</h3>
      <el-tabs :tab-position="tabPosition" v-model="activeTabName">
        <el-tab-pane label="Payslip" name="payslip">
          <PayslipForm titleText="Payslip" @generatePayslip="generatePayslip" />
        </el-tab-pane>
        <el-tab-pane label="General Report" name="general">
          <ReportForm />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import ReportForm from "../components/ReportForm";
import PayslipForm from "../components/PayslipForm";

export default {
  components: {
    ReportForm,
    PayslipForm,
  },

  data() {
    return {
      tabPosition: "left",
      activeTabName: "payslip",
    };
  },
  mounted() {
    this.activeTabName = this.$store.state.ess.payroll.report.activeTabName;
  },
  destroyed() {
    this.$store.commit("ess/payroll/report/activeTabName", this.activeTabName);
  },
  methods: {
    generatePayslip(reportParams) {
      this.$router.push({
        name: "payslip",
        params: { reportParams },
      });
    },
    generateReport() {},
  },
};
</script>
<style></style>
